<template>
  <div class="banner banner--active discount-banner">
    <div class="banner__inner discount-banner__inner">
      <div class="banner__left">
        <h3 class="banner__title discount-banner__title">
          {{$t('discount_banner.title')}}
        </h3>
        <div class="banner__description discount-banner__description">
          <ul class="discount-banner__list">
            <li>
              {{$t('discount_banner.no_commission')}}
            </li>
            <li>
              {{$t('discount_banner.no_bank_card')}}
            </li>
            <li>
              {{$t('discount_banner.safely')}}
            </li>
          </ul>
        </div>
      </div>
      <div class="banner__right">
        <div class="banner__img">
          <img
            src="@/assets/img/sale.png"
            alt="banner-img"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    return {
      t
    };  
  },
});
</script>
<style lang="scss" scoped>
.discount-banner{
    &__title{
        margin-bottom: 28px;
    }
    &__list{
        list-style: none;
    }
    &__left{
      flex: 3;
    }
}
@media (min-width: 320px) and (max-width: 768px) {
    .discount-banner{
    &__title{
        margin-bottom: 16px;
    }
}
}
</style>